import styled from "styled-components";
import { colors, font, radius } from "../../styles/theme/tokens";

export const Button = styled.button`
   display: flex;
   align-items: center;
   gap: 12px;
   width: 100%;
   padding: 11px 14px;
   border-radius: ${radius.md};
   font-family: ${font.text};
   font-size: 15px;
   font-weight: 600;
   color: ${colors.muted};
   background: transparent;
   cursor: pointer;
   transition: background 0.15s ease, color 0.15s ease;

   &:hover {
      color: ${colors.danger};
      background: ${colors.dangerSoft};
   }
`
